import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { UrlParams, PaginatedPayRateList, PayRate } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
  queryKey: (string | undefined | string[])[];
}

interface IUsePayRates {
  search?: string;
  ordering?: string;
  limit?: string;
  payRateTypes?: PayRate['payRateType'][];
}

function usePayRates({
  search,
  ordering,
  payRateTypes,
  limit = '20',
}: IUsePayRates): UseInfiniteQueryResult<AxiosResponse<PaginatedPayRateList>> {
  const fetchPayRates = ({
    pageParam = { limit, offset: '0' },
  }: QueryKeyType): Promise<AxiosResponse<PaginatedPayRateList>> => {
    const params = pageParam;

    if (search) {
      params.search = search;
    }

    if (ordering) {
      params.ordering = ordering.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
    }

    if (payRateTypes && payRateTypes.length > 0) {
      params.pay_rate_types = payRateTypes.join(',');
    }

    return client.get(`pay-rates/?${encodeUrlParams(params)}`);
  };

  return useInfiniteQuery(['payRates', search, ordering, payRateTypes], fetchPayRates, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}

export default usePayRates;
